/* Storiesrij: een tik op een duimnagel opent de film beeldvullend.
 *
 * De film wordt hier pas aangemaakt, niet bij het laden van de pagina. Vijf
 * video-elementen die allemaal hun eerste stukje ophalen kosten megabytes en
 * een trage eerste render, en op iOS starten ze toch niet vanzelf.
 *
 * <dialog> doet het zware werk: focusval, Escape, en de donkere achtergrond.
 * Zonder ondersteuning valt het terug op gewoon niets doen in plaats van een
 * kapotte overlay.
 */
(() => {
  function speler(knop, soort) {
    // Fotostand: het beeld zelf vergroten. De film blijft in het blok staan,
    // zodat wisselen tussen de twee standen niets kost.
    if (soort === 'foto') {
      const bron = knop.querySelector('img');
      if (!bron) return null;
      const i = document.createElement('img');
      // De duimnagel is 320px breed; voor de vergroting staat een
      // grotere bron klaar op de knop zelf.
      i.src = knop.dataset.jwGroot || bron.currentSrc || bron.src;
      i.alt = bron.alt || '';
      return i;
    }
    const film = knop.dataset.jwFilm;
    const insluiting = knop.dataset.jwInsluiting;

    if (film) {
      const v = document.createElement('video');
      v.src = film;
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      const poster = knop.querySelector('img');
      if (poster) v.poster = poster.currentSrc || poster.src;
      return v;
    }

    if (insluiting) {
      // youtu.be/xxx, youtube.com/watch?v=xxx en vimeo.com/xxx omzetten naar de
      // insluit-URL; een adres dat al een embed is blijft zoals het is.
      let url = insluiting.trim();
      const yt = url.match(/(?:youtu\.be\/|[?&]v=)([\w-]{6,})/);
      const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (yt) url = `https://www.youtube.com/embed/${yt[1]}?autoplay=1&playsinline=1`;
      else if (vm) url = `https://player.vimeo.com/video/${vm[1]}?autoplay=1`;
      const f = document.createElement('iframe');
      f.src = url;
      f.allow = 'autoplay; fullscreen; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      f.title = knop.querySelector('figcaption')?.textContent || 'Video';
      return f;
    }
    return null;
  }

  function koppel(rij) {
    if (rij.dataset.jwGekoppeld) return;
    rij.dataset.jwGekoppeld = '1';

    const dialoog = rij.querySelector('[data-jw-stories-dialog]');
    const doos = rij.querySelector('[data-jw-stories-speler]');
    if (!dialoog || !doos || typeof dialoog.showModal !== 'function') return;

    const leeg = () => { doos.textContent = ''; };
    dialoog.addEventListener('close', leeg);
    dialoog.querySelector('[data-jw-stories-sluit]')?.addEventListener('click', () => dialoog.close());
    // Buiten de film tikken sluit hem ook; dat verwacht iedereen van zo'n overlay.
    dialoog.addEventListener('click', (e) => { if (e.target === dialoog) dialoog.close(); });

    const soort = rij.querySelector('.jw-sty')?.dataset.jwSoort || 'film';
    dialoog.classList.toggle('jw-sty__d--foto', soort === 'foto');

    rij.querySelectorAll('.jw-sty__t').forEach((knop) => {
      knop.addEventListener('click', () => {
        const el = speler(knop, soort);
        if (!el) return;
        leeg();
        doos.appendChild(el);
        dialoog.showModal();
      });
    });
  }

  function start() {
    document.querySelectorAll('.jw-sty').forEach((r) => koppel(r.parentElement || r));
    // De rij en de dialoog zijn broers, dus koppelen gebeurt op hun gedeelde ouder.
  }

  document.addEventListener('DOMContentLoaded', start);
  if (document.readyState !== 'loading') start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:block:select', start);
})();
